import React, { useEffect, useState } from "react";
import "../assets/css/Panel.css";
import Navbar from "../components/Navbar";
import {api} from "../utils/gashtaltAPI";
import ErrorPage from "../components/ErrorPage";
import { RiFileExcel2Line } from "react-icons/ri";
import DownloadHandler from "../utils/downloadHandler";
import Loader from "../components/Loader";
import {Table, TableContainer, Tbody, Td, Thead, Tr} from "@chakra-ui/react";
import {toPersianNumber} from "../utils/numberConversion";
import {getJalaliDate} from "../utils/dateConversion";
import {useParams} from "react-router-dom";
import FilterTd from "../components/FilterTd";
import TableToolbar from "../components/TableToolbar";
import Pagination from "../components/Pagination";
import EmptyState from "../components/EmptyState";

function Invoices() {
  const { productType,productId } = useParams();
  const [params,setParams] = useState({
    product_type : productType,
    product_id : productId
  })
  const [invoices, setInvoices] = useState([]);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading,setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/api/invoices?page=${currentPage}`,{
          params : params
        });
        setInvoices(response.data.data);
        setCurrentPage(response.data.current_page);
        setStartIndex(response.data.from);
        setLastPage(response.data.last_page);
        setTotal(response.data.total);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [currentPage,params]);

  if (loading) return <Loader />
  if (error) return <ErrorPage error={error} />;
  return (
    <div className="d-flex flex-column h-100">
      <Navbar />
      <div className="admin-page flex-fill">
        <TableToolbar title="پرداخت ها" count={total}>
          <button
              className="btn btn-outline-green d-flex align-items-center gap-1"
              onClick={() => {
                DownloadHandler(
                    `${api.defaults.baseURL}/api/invoices/export`,
                    "invoices.xlsx",
                    { params }
                );
              }}
          >
            <RiFileExcel2Line style={{fontSize: '1.1rem'}}/>
            خروجی اکسل
          </button>
        </TableToolbar>

        <div className="admin-table-card">
          <TableContainer>
            <Table variant="striped" colorScheme="teal">
              <Thead>
                <Tr>
                  <Td>ردیف</Td>
                  <Td>
                    <FilterTd
                        name={"نام و نام خانوادگی"}
                        defaultValue={params.name}
                        onSubmit={(value) => {
                          setCurrentPage(1);
                          setParams((prevFilters) => ({
                            ...prevFilters,
                            name: value,
                          }));
                        }}
                        onCancel={() => {
                          setCurrentPage(1);
                          setParams((prevFilters) => {
                            const { name, ...rest } = prevFilters;
                            return rest;
                          });
                        }}
                    />
                  </Td>
                  <Td>
                    <FilterTd
                        name={"شماره همراه"}
                        defaultValue={params.phone_number}
                        onSubmit={(value) => {
                          setCurrentPage(1);
                          setParams((prevFilters) => ({
                            ...prevFilters,
                            phone_number: value,
                          }));
                        }}
                        onCancel={() => {
                          setCurrentPage(1);
                          setParams((prevFilters) => {
                            const { phone_number, ...rest } = prevFilters;
                            return rest;
                          });
                        }}
                    />
                  </Td>
                  <Td>محصول</Td>
                  <Td>مبلغ</Td>
                  <Td>کد تخفیف</Td>
                  <Td>مقدار تخفیف</Td>
                  <Td>تاریخ</Td>
                </Tr>
              </Thead>
              <Tbody>
                {invoices.map((invoice, index) => (
                    <Tr key={invoice.id ?? `${invoice.user_name}-${index}`}>
                      <Td>{toPersianNumber(startIndex+index)}</Td>
                      <Td>{invoice.user_name}</Td>
                      <Td style={{direction:'ltr',textAlign:'end'}}>{toPersianNumber(invoice.user_phone)}</Td>
                      <Td>{toPersianNumber(invoice.product_name)}</Td>
                      <Td>{toPersianNumber(invoice.price)} تومان</Td>
                      <Td>{toPersianNumber(invoice.discount_code ?? '--')}</Td>
                      <Td>{toPersianNumber(invoice.discount_code ? invoice.discount_amount + ' تومان' : '--')}</Td>
                      <Td style={{direction:'ltr',textAlign:'end'}}>{toPersianNumber(getJalaliDate(invoice.issue_date))}</Td>
                    </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
          {invoices.length === 0 && <EmptyState text="پرداختی یافت نشد." />}
        </div>

        <Pagination currentPage={currentPage} lastPage={lastPage} onChange={setCurrentPage} />
      </div>
    </div>
  );
}

export default Invoices;
